var axios = require('axios')
$(document).ready(function() {

  if($('.cart_body h1').text() == "moja košarica") {
    check_availability();
  }

  function check_availability() {
    has_red_one = false;
    $('.control_quantity span').each(function(){
      var user_want = parseInt($(this).text());
      var available = parseInt($(this).next().attr('data-item-stock'));
      if(user_want > available) {
        has_red_one = true;
        $(this).parent().parent().parent().css("border", "2px solid red");
        $('footer .notification').html("<p style='color: red; font-weight: bold'>Proizvod označen crveno više nije dostupan, molimo da smanjite količinu.</p>");
        $('footer .black_filled_button').attr("href", "");
      }
    });
    if(has_red_one == false) {
      $('footer .notification').html("");
      $('footer .black_filled_button').attr("href", "/kupi-proizvode");
    }
  }

  $(document).on('click', '.control_quantity img', function(){
    if(this.src.match(/minus/)){
      var extra_param = '?type=sub'
    }

    if (parseInt($('.control_quantity span').text()) >= parseInt($(this).attr('data-item-stock'))) {
      alert("Ne možete povećati količinu jer željena količina nije dostupna!");
    } else {
      axios.get('/cart/buy/' + $(this).attr('data-item-id') + extra_param).then(() => {
        $((this)).parent().parent().parent().css('opacity', 0.6)
          axios.get('/cart_items').then((response) => {
            $('#cart_items_holder').html(response.data);
            check_availability();
            }
          )
        }
      );
    }
  })

  $(document).on('click', '.remove_item', function(){
    axios.get('/cart/buy/' + $(this).attr('data-item-id') + '?type=del').then(() => {
      $((this)).parent().parent().css('opacity', 0.2)
        axios.get('/cart_items').then((response) => {
          $('#cart_items_holder').html(response.data);
          check_availability();
          }
        )
      }
    );
  })

  $(document).on('change', '.delivery_options', function(){
    var delivery_price = $(this).attr('data-price') ? parseFloat($(this).attr('data-price')) : 0
    var tokens = parseFloat($('.summary_gift_tokens span').text().replace(',', '.')) || 0
    var new_price = parseFloat($('.summary_total_no_pdv span').text().replace(',', '.')) + delivery_price - tokens
    $('.summary_fixed_total span').text(new_price.toFixed(2))

    var baseHref = $('#create_order_link').attr("href").replace(/(\?|&)d=[^&]*/, '').replace(/\?$/, '')
    var separator = baseHref.includes('?') ? '&' : '?'
    $('#create_order_link').attr("href", baseHref + separator + 'd=' + $(this).val())
    $('#create_order_txt').hide();
    $('#create_order_link').css("display", "flex");
  })


});



// WEBPACK FOOTER //
// app/frontend/javascripts/cart.js